/**
 * Format distance in meters as "X km" with space as thousands separator.
 */
export function formatFlightDistance(meters: number): string {
  if (meters <= 0) return '0 km';
  return `${(meters / 1000).toLocaleString('en-US').replace(/,/g, ' ')} km`;
}
